import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useContext } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { getSizedBricoStyles } from "./CardVlp.styles";
import { SizeContext } from "../../../atoms/contexts/SizeContext";
export var BricoVlp = function BricoVlp(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'fr' : _ref$variant,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'Prix bas permanent' : _ref$text;
  var _useContext = useContext(SizeContext),
    _useContext$sizes = _useContext.sizes,
    sizes = _useContext$sizes === void 0 ? ['sm', 'lg'] : _useContext$sizes;
  if (!sizes || !sizes.length) return null;
  return /*#__PURE__*/React.createElement(Flex, {
    flexWrap: "wrap",
    justify: "center",
    lineHeight: 1.1,
    bg: "primary-00-yellow",
    py: 1,
    px: 3,
    color: "red.primary",
    fontFamily: "bold",
    fontSize: "2xs",
    textTransform: "uppercase",
    sx: _objectSpread({}, getSizedBricoStyles(sizes, variant)),
    "data-testid": "molecules-CardVlp-Flex"
  }, text.split(' ').map(function (w, i) {
    return /*#__PURE__*/React.createElement(Text, {
      key: i,
      sx: _objectSpread(_objectSpread({}, variant !== 'fr' && {
        '&:first-of-type': {
          color: 'black'
        }
      }), variant === 'fr' && {
        '&:last-child': {
          color: 'black'
        }
      })
    }, w, "\xA0");
  }));
};